import { validatePasswordSetup } from "./checkout-utils";
import Modal from "../Modal";

const initPayOnArrivalPaymentMode = () => {
  const paymentMethodRadios = document.querySelectorAll('input[name="payment_method"]');
  const prepaySubmitBtn = document.getElementById('prepay-submit-btn');
  const poaSubmitBtn = document.getElementById('poa-submit-btn');
  const amountRecapPrepaidElts = document.querySelectorAll('.amount-recap-prepaid');
  const amountRecapPoaElts = document.querySelectorAll('.amount-recap-poa');
  const hideOnPoaElts = document.querySelectorAll('.hide-on-poa');
  const hideOnPrepayElts = document.querySelectorAll('.hide-on-prepay');
  const paymentForm = document.getElementById('payment-form');
  const discountNotAvailableModal = document.getElementById('discountNotAvailableModal');

  if (!paymentMethodRadios.length || !prepaySubmitBtn || !poaSubmitBtn || !paymentForm) {
    return;
  }

  // Get form actions from data attributes
  const onlineAction = paymentForm.dataset.onlineAction;
  const poaAction = paymentForm.dataset.poaAction;

  const handlePaymentMethodChange = (e, options = {}) => {
    const isPayOnArrival = e.target.value === 'pay_on_arrival';

    // When switching to Pay on Arrival with incompatible discount/gift card: show modal and keep prepay (skip if user confirmed in modal)
    if (isPayOnArrival && discountNotAvailableModal && !options.confirmedPoaSwitch) {
      const onlineRadio = document.querySelector('input[name="payment_method"][value="online"]');
      if (onlineRadio) {
        onlineRadio.checked = true;
      }
      Modal.toggleModal('#discountNotAvailableModal');
      return;
    }

    // Change form action
    if (isPayOnArrival && poaAction) {
      paymentForm.action = poaAction;
    } else if (!isPayOnArrival && onlineAction) {
      paymentForm.action = onlineAction;
    }

    // Update payment type data attribute
    paymentForm.dataset.paymentType = isPayOnArrival ? 'pay_on_arrival' : 'prepay';

    // Toggle submit buttons
    if (isPayOnArrival) {
      prepaySubmitBtn.classList.add('hidden');
      poaSubmitBtn.classList.remove('hidden');
    } else {
      prepaySubmitBtn.classList.remove('hidden');
      poaSubmitBtn.classList.add('hidden');
    }

    // Toggle amount recap visibility
    if (amountRecapPrepaidElts) {
      if (isPayOnArrival) {
        amountRecapPrepaidElts.forEach(elt => {
          elt.classList.add('hidden');
        });
      } else {
        amountRecapPrepaidElts.forEach(elt => {
          elt.classList.remove('hidden');
        });
      }
    }

    if (amountRecapPoaElts) {
      if (isPayOnArrival) {
        amountRecapPoaElts.forEach(elt => {
          elt.classList.remove('hidden');
        });
      } else {
        amountRecapPoaElts.forEach(elt => {
          elt.classList.add('hidden');
        });
      }
    }

    // Toggle hide-on-poa: hidden when Pay on arrival, visible when prepay
    hideOnPoaElts.forEach(elt => {
      elt.classList.toggle('hidden', isPayOnArrival);
    });

    // Toggle hide-on-prepay: visible when Pay on arrival, hidden when prepay
    hideOnPrepayElts.forEach(elt => {
      elt.classList.toggle('hidden', !isPayOnArrival);
    });

    // When switching to Pay Online: clear orange border on all code inputs in POA recap
    if (!isPayOnArrival) {
      document.querySelectorAll('.checkout-input-code--poa-error').forEach(el => el.classList.remove('checkout-input-code--poa-error'));
    }
  };

  // Add event listeners to all payment method radios
  paymentMethodRadios.forEach(radio => {
    radio.addEventListener('change', handlePaymentMethodChange);
  });

  // "Continue with Pay on Arrival" in discount-not-available modal: close modal then switch to POA
  if (discountNotAvailableModal) {
    const confirmPoaBtn = discountNotAvailableModal.querySelector('[data-discount-not-available-confirm-poa]');
    if (confirmPoaBtn) {
      confirmPoaBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        Modal.closeAllModals();

        const poaRadio = document.querySelector('input[name="payment_method"][value="pay_on_arrival"]');
        if (poaRadio) {
          poaRadio.checked = true;
          handlePaymentMethodChange({ target: poaRadio }, { confirmedPoaSwitch: true });
        }
      });
    }
  }

  // Handle form submit (e.g. Enter key) when POA is selected
  paymentForm.addEventListener('submit', (e) => {
    if (paymentForm.dataset.paymentType !== 'pay_on_arrival') {
      // Let Stripe / normal handler manage non-POA submissions
      return;
    }

    e.preventDefault();
    poaSubmitBtn.disabled = true;
    poaSubmitBtn.classList.add('loading');

    // Validate password setup (create account flow) like in FreeCheckout
    if (!validatePasswordSetup(paymentForm)) {
      poaSubmitBtn.disabled = false;
      poaSubmitBtn.classList.remove('loading');
      return false;
    }

    // Validate form validity
    if (!paymentForm.checkValidity()) {
      poaSubmitBtn.disabled = false;
      poaSubmitBtn.classList.remove('loading');
      return false;
    }

    // GA4 - Experience purchase for pay on arrival
    try {
      const cookiesBlocked = document.querySelector('[name=cookies_blocked]');
      const gtmBlocked = document.querySelector('[name=gtm_blocked]');
      if (cookiesBlocked && gtmBlocked) {
        if (window.navigator && !window.navigator.cookieEnabled) {
          cookiesBlocked.value = '1';
        }
        if (window && window.google_tag_manager === undefined) {
          gtmBlocked.value = '1';
        }
      }

      if (typeof dataLayer !== 'undefined') {
        const expAnalyticsBlock = document.getElementById('experience-data');
        if (expAnalyticsBlock) {
          dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer.push({
            event: 'purchase',
            ecommerce: {
              transaction_id: expAnalyticsBlock.dataset.transactionId,
              items: [{
                item_id: expAnalyticsBlock.dataset.experienceId,
                item_name: expAnalyticsBlock.dataset.experienceName,
                item_brand: expAnalyticsBlock.dataset.hostName,
                item_category: expAnalyticsBlock.dataset.categoryOne,
                item_category2: expAnalyticsBlock.dataset.categoryTwo,
                item_category3: expAnalyticsBlock.dataset.categoryThree,
                item_category4: expAnalyticsBlock.dataset.categoryFour,
                quantity: 1,
              }],
            },
          });
        }
      }
    } catch (error) {
      // We do not want to block the booking if tracking fails
      console.error(error);
    }

    paymentForm.submit();
  });
}

export { initPayOnArrivalPaymentMode };
